import { BaseModel } from './BaseModel';
import User from './User';

export class UserJobStatus extends BaseModel {
  static get entity() {
    return 'user-job-statuses';
  }

  static get fk() {
    return 'user_job_status_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      user_id: this.attr(null),
      user: this.belongsTo(User, 'user_id'),
      working_status: this.attr(null),
      company: this.attr(null),
      area_of_employment: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      async find() {
        return this.get(`/user-job-statuses`, {
          save: false
        });
      },
      async create(body) {
        return this.post('/user-job-statuses', body);
      },
      async update(id, body) {
        return this.put(`/user-job-statuses/${id}`, body);
      }
    }
  };
}

export default UserJobStatus;
